import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      navigate("/"); // Redirect to the home page
    } catch (error) {
      setError("Error creating account. Please try again.");
      console.error("Error during sign-up:", error);
    }
  };

  return (
    <div style={styles.container}>
      <img
        src="/logo-real.png"
        alt="Roster Logo"
        style={styles.logo}
      />
      <div style={styles.card}>
        <form onSubmit={handleSignup} style={styles.form}>
          <label htmlFor="email" style={styles.label}>
            Email
          </label>
          <input
            type="email"
            id="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
          />
          <label htmlFor="password" style={styles.label}>
            Password
          </label>
          <input
            type="password"
            id="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
            autoComplete="new-password"
          />

          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.signupButton}>
            Create Account
          </button>
        </form>
        <p style={styles.footer}>
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            style={styles.link}
          >
            Sign in
          </span>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f7f7f7",
  },
  logo: {
    width: "270px",
    marginBottom: "40px", // Adds space below the logo
  },
  card: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "400px",
  },
  title: {
    fontSize: "24px",
    marginBottom: "20px",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "5px",
    fontSize: "14px",
    fontWeight: "500",
  },
  input: {
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ddd",
    marginBottom: "15px",
    fontSize: "14px",
    outline: "none",
  },
  error: {
    color: "red",
    fontSize: "14px",
    marginBottom: "15px",
  },
  signupButton: {
    backgroundColor: "#4285F4",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
  },
  footer: {
    fontSize: "14px",
    textAlign: "center",
    marginTop: "15px",
  },
  link: {
    color: "#4285F4",
    cursor: "pointer",
    textDecoration: "underline",
  },
};

export default SignUp;
